import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';

export default function AudioHubEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [chatDisplayName, setChatDisplayName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);
    const defaultOtherConfig = { audio_codec: '', callType: 'video' };
    const other_config = { ...defaultOtherConfig, ...eventModuleRow.other_config, callType: 'video' };

    useEffect(() => {
        setChatDisplayName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
        if (eventModuleRow.other_config?.callType !== 'video') {
            updateEventModuleRow({
                name: eventModuleRow.name,
                colour: eventModuleRow.colour,
                other_config,
                event_grouping_seq: eventModuleRow.event_grouping_seq,
                module_type_id: eventModuleRow.module_type_id,
            });
        }
    }, [eventModuleRow]);

    function handleChange(e) {
        const newName = e.target.value;
        setChatDisplayName(newName);
        updateEventModuleRow({
            name: newName,
            colour: bStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        updateEventModuleRow({
            name: chatDisplayName,
            colour: newStyle,
            other_config,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    return (
        <div>
            <input type="text" style={{ width: '50%' }} className="form-control input-md"
                name="chatDisplayName" value={chatDisplayName}
                onChange={handleChange} placeholder="Enter Chat Display Name" />
            <SelectColourButton
                title="Select Colour"
                groupingSequence={eventModuleRow.event_grouping_seq}
                selectedColour={colourSelected}
                bStyle={bStyle} />
        </div>
    );
}
